import Admin from "../Admin";
import React from "react";
import CardAdminLocationList from "../../../Component/Card/Admin/Location/CardAdminLocationList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminLocationList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminLocationList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/location",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Locations" buttons={buttons} />;
  }
}
